import React from 'react';
import { MdClose } from 'react-icons/md';
import Modal from 'react-responsive-modal';

function DeleteTaskModal({ isOpen, onClose, onConfirmDelete }) {

    const closeIcon = <MdClose className="text-3xl mt-1 text-white" />;

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            container={document.getElementById('root')}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModalTask',
            }}
        >
            <div className="">
                <h2 className="text-base font-semibold text-white">
                    Delete task ?
                </h2>
                <div className="deletedPopup !right-20 z-50">
                    <div className="text-sm text-white py-5">Are you sure you want to delete this task?</div>
                    <div className='flex gap-2 justify-center'>
                        <div
                            className="px-5 py-1.5 text-white border border-white rounded-full text-sm"
                            onClick={onClose}
                        >
                            Cancel
                        </div>
                        <div
                            className="px-5 py-1.5 text-white rounded-full bg-red-600 text-sm"
                            onClick={onConfirmDelete}
                        >
                            Delete
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default DeleteTaskModal;